import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

export const BUTTON_CONTAINER_HEIGHT = Device.isTabletOrWeb ? 80 : 120;

let baseStyles = {
    childrenWrapper: {
        marginBottom: BUTTON_CONTAINER_HEIGHT
    },
    buttonsContainer: {
        paddingHorizontal: Theme.primaryMargin,
        height: BUTTON_CONTAINER_HEIGHT,
        backgroundColor: Theme.primaryBackgroundColor,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row'
    },
    buttonsWrapper: {
        flexDirection: 'row',
        justifyContent: 'center'
    },
    containerButton: {
        marginHorizontal: 10,
        minWidth: Theme.BU * 10
    },
    backgroundContainer: {
        flex: 1,
        backgroundColor: Theme.primaryBackgroundColor
    }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        buttonsContainer: {
            ...baseStyles.buttonsContainer,
            justifyContent: 'flex-end'
        },
        buttonsContainerSelectAll: {
            justifyContent: 'space-between'
        }
    };
}

export default StyleSheet.create(baseStyles);
